declare global {
  interface Window {
    env?: {
      [key: string]: string | undefined;
    };
  }
}

/**
 * Get environment variable value
 * Prioritizes window.env over process.env
 */
const getEnv = (key: string): string | undefined => {
  return window.env?.[key] ?? process.env[key];
};

// Common environment variables as constants for easy access
export const ENV = {
  NODE_ENV: getEnv('NODE_ENV') || 'development',
  PUBLIC_URL: getEnv('PUBLIC_URL') || '',
  REACT_APP_SENTRY_DSN: getEnv('REACT_APP_SENTRY_DSN') || '',
  REACT_APP_API_ENDPOINT: getEnv('REACT_APP_API_ENDPOINT') || 'https://raf-dev.referezunami.com',
  CANADAPOST_KEY: getEnv('CANADAPOST_KEY') || 'WE49-GE25-EC17-TU77',
};
